import Select from './Select';
import Inline from './Inline';
import Option from './Option';
import OptionGroup from './OptionGroup';
import Value from './Value';
import { toggleValue } from './utils';
Select.Inline = Inline;
Select.Option = Option;
Select.OptionGroup = OptionGroup;
Select.Value = Value;
Select.toggleValue = toggleValue;
export default Select;